import { GenderE } from "../components/Gender/Gender";
import { Util } from "./Util";

export enum HeightUnits {
	feet = 1,
	cm = 2,
}

export enum WeightUnits {
	lbs = 1,
	kg = 2,
}

export interface Height {
	heightCm?: number;
	heightFt?: number;
	heightInch?: number;
	selectedUnit?: HeightUnits;
}

export interface Weight {
	weightKg?: number;
	weightLbs?: number;
	selectedUnit?: WeightUnits;
}

export class Details {
	age?: number;
	gender?: GenderE;
	height?: Height;
	weight?: Weight;

	setAge(age: number): boolean {
		if (age < 18 || age > 120) {
			return false;
		} else {
			this.age = age;
			return true;
		}
	}

	setGender(gender: GenderE) {
		this.gender = gender;
	}

	setHeight(height: Height): boolean {
		if (typeof height === "undefined") {
			return false;
		}
		if (Util.validateHeight(height)) {
			if (
				typeof height.heightFt !== "undefined" &&
				typeof height.heightInch !== "undefined" &&
				height.selectedUnit === HeightUnits.feet
			) {
				const heightFt = (isNaN(height.heightFt))? 0 : height.heightFt;
				const heightInch = (isNaN(height.heightInch))? 0 : height.heightInch
				this.height = {
					heightFt: heightFt,
					heightInch: heightInch,
					heightCm: Util.convertFtToCm(heightFt, heightInch),
					selectedUnit: height.selectedUnit,
				};
				return true;
			} else if (typeof height.heightCm !== "undefined" && height.selectedUnit === HeightUnits.cm) {
				const heightFt = Util.convertCmToFt(height.heightCm);
				this.height = {
					heightFt: heightFt.feet,
					heightInch: heightFt.inches,
					heightCm: height.heightCm,
					selectedUnit: height.selectedUnit,
				};
				return true;
			} else {
				return false;
			}
		} else {
			return false;
		}
	}

	setWeight(weight: Weight): boolean {
		if (typeof weight === "undefined") {
			return false;
		}

		if (Util.validateWeight(weight)) {
			if (typeof weight.weightKg !== "undefined" && weight.selectedUnit === WeightUnits.kg) {
				this.weight = {
					weightKg: weight.weightKg,
					weightLbs: Util.convertKgToLbs(weight.weightKg),
					selectedUnit: weight.selectedUnit,
				};
				return true;
			} else if (typeof weight.weightLbs !== "undefined" && weight.selectedUnit === WeightUnits.lbs) {
				this.weight = {
					weightKg: Util.convertLbsToKg(weight.weightLbs),
					weightLbs: weight.weightLbs,
					selectedUnit: weight.selectedUnit,
				};
				return true;
			} else {
				return false;
			}
		} else {
			return false;
		}
	}

	getWeight(): string{
		return Util.getWeight(this.weight!);
	}
}
